'use client';

import { Toaster } from 'react-hot-toast';

export const HotToaster = () => {
  return (
    <Toaster
      // Above every app layer, the Content Studio (z-100000+) and its dialogs included: a toast
      // drawn under them can't be read, and its button (Save video) can't be clicked.
      containerStyle={{ zIndex: 100300 }}
      toastOptions={{
        // Define default options
        className: '!mt-12',
      }}
    />
  );
};
